/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import Request from '../request';

export const createMessageAttachments = (supplierId, documentLists) => {
  return Request.call({
    url: `/micro/suppliers/${supplierId}/messages/attachments`,
    method: 'POST',
    data: {
      documentListIds: documentLists,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const saveAttachmentToSupplier = async (supplierId, documentLists)=>{
  return Request.call({
    url: `/micro/suppliers/${supplierId}/messages/attachments/save-to-profile`,
    method: 'POST',
    data: {
      documentListIds: documentLists,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
}